import PropTypes from 'prop-types';
import cn from 'classnames';
import React, {Component} from 'react';
import css from './css.css';
import ActionBar from '~/components/Bar/Bar';
import Pagination from '~/components/Pagination/Pagination';
import PerPageSwitch from '~/components/PerPageSwitch/PerPageSwitch';
import ElementTooltipContainer from "~/components/Tooltip/ElementTooltipContainer";

export default class PaginationBar extends Component {
    static propTypes = {
        readOnlyPerPage: PropTypes.bool.isRequired,
        autoHidePagination: PropTypes.bool,
    };

    static defaultProps = {
        readOnlyPerPage: false,
        tooltipsActive: false,
        autoHidePagination: false,
    };

    renderPerPageSwitch() {
        return (<PerPageSwitch
            perPage={this.props.perPage}
            currentPage={this.props.currentPage}
            total={this.props.total}
            onPerPageChange={this.props.readOnlyPerPage ? null : this.props.onChangePerPage}
            trans={this.props.trans}
            readOnly={this.props.readOnlyPerPage}
            tooltip={this.props.perPageTooltip}
        />);
    }

    renderPagination() {
        return (<Pagination
            perPage={this.props.perPage}
            currentPage={this.props.currentPage}
            total={this.props.total}
            maxPages={this.props.maxPages}
            onPageChange={this.props.onChangePage}
            tooltipsActive={this.props.tooltipsActive}
            trans={this.props.trans}
            tooltip={this.props.paginationTooltip}
        />);
    }

    render() {
        if (this.props.autoHidePagination && this.props.total <= 1) {
            return null;
        }
        return (
            <ActionBar
                className={cn(css.paginationBar, this.props.className)}
                left={this.renderPerPageSwitch()}
                right={this.renderPagination()}
                children={true}
            />
        );
    }
}